<template>
	<div class="content-box-wrapper login-box content-box-padding">
		<div class="content-box-header bg-gradient-17">
			<h2 class="content-box-header__headline text-white text-center">
				Skapa konto
			</h2>
		</div>
		<div class="content-box-wrapper content-box-padding-sm">
			<p>
				Här kan du skapa ett konto för att få tillgång till Målmedvetet
				näringsliv.
			</p>

			<form action="" @submit.prevent="">
				<div class="form-group">
					<label>Din mejladress</label>
					<input
						type="email"
						v-model="email"
						placeholder="Din e-mail"
						name="email"
						required
					/>
					<p class="description">
						Ange din mejladress. Du använder denna för att logga in.
					</p>
				</div>
				<div class="form-group">
					<label>Ditt lösenord</label>
					<input
						type="password"
						v-model="password"
						placeholder="Ditt lösenord"
						name="password"
						required
					/>
					<p class="description">
						Ange ditt lösenord.
					</p>
				</div>
				<div class="form-group">
					<label>Din roll</label>

					<select v-model="user_role" name="user_role">
						<option value="owner">Ansvarig</option>
						<option value="regular">Anställd</option>
					</select>
					<p class="description">
						Välj vilken roll du ska ha. Om du är ansvarig så blir du
						ansvarig och kan bjuda in andra personer till din grupp.
						Om du är anställd så kan du gå med i en befintlig grupp
						som en ansvarig person har skapat.
					</p>
				</div>
				<div class="form-group" v-if="user_role == 'owner'">
					<label>Gruppnamn</label>

					<input
						type="text"
						v-model="group_name"
						name="group_name"
						placeholder="Ditt gruppnamn"
					/>
					<p class="description">
						Ange namnet på din grupp. Detta kan med fördel vara
						namnet på din arbetsplats eller organisation.
					</p>
				</div>
				<div class="form-group" v-if="user_role == 'owner'">
					<label>Ditt företag eller din organisation</label>

					<input
						type="text"
						v-model="company_name"
						name="company_name"
						placeholder="Ditt företag eller din organisation"
					/>
					<p class="description">
						Ange vilket företag eller vilken organisation du
						representerar.
					</p>
				</div>
				<div class="form-group" v-if="user_role == 'owner'">
					<label>Din arbetsroll</label>

					<input
						type="text"
						v-model="job_role"
						name="job_role"
						placeholder="Din arbetsroll"
					/>
					<p class="description">
						Ange vilken tjänst du har på din arbetsplats eller
						organisation.
					</p>
				</div>
				<div class="form-group" v-if="user_role == 'regular'">
					<label>Gruppkod</label>
					<input
						type="text"
						v-model="group_key"
						placeholder="Din gruppkod"
						name="group_key"
					/>
					<p class="description">
						Gå med i en befintlig grupp genom att ange gruppkoden
						här. Om du inte har någon gruppkod kan du fråga en
						ansvarig på ditt företag eller organisation om
						gruppkoden.
					</p>
				</div>
				<div class="form-group">
					<label>Inbjudningskod</label>
					<input
						type="text"
						v-model="invitation_code"
						placeholder="Din inbjudningskod"
						name="invitation_code"
					/>
					<p class="description">
						Just nu är detta verktyg i ett betastadie och därför
						behöver du en inbjudningskod för att kunna skapa ett
						konto. Ange din inbjudningskod här. Om du inte har en
						inbjudningskod kan du kontakta UNDP på
						<a href="mailto:fragor@undp.org">fragor@undp.org</a>.
					</p>
				</div>
				<div class="form-group">
					<label
						for="privacy_policy"
						class="d-flex align-items-center margin-bottom-xs-1"
					>
						<input
							type="checkbox"
							v-model="privacy_policy"
							name="privacy_policy"
							id="privacy_policy"
							class="pr-2 mb-0"
						/>
						<span class="pl-4"
							>Jag godkänner personuppgiftspolicyn</span
						></label
					>
					<p class="description">
						Godkänn att dina personuppgifter sparas enligt
						<a href="/personuppgiftspolicy" target="_blank"
							>personuppgiftspolicyn</a
						>.
					</p>
				</div>
				<div class="form-group margin-top-xs-2">
					<input
						type="submit"
						class="pem-btn pem-btn-primary
					pem-btn-block"
						value="Skapa konto"
						:class="{ 'loading loading-icon-white': isLoading }"
						@click.prevent="doSignup"
					/>
				</div>
			</form>

			<Message
				v-for="message in messages"
				:text="message.text"
				:type="message.type"
				:key="message.text"
			/>

			<div class="margin-top-xs-2">
				<div class="row justify-content-between">
					<div class="col-auto">
						<a
							href="#"
							@click.prevent="$store.commit('sidebar', 'login')"
							>Logga in</a
						>
					</div>
					<div class="col text-right">
						<a
							href="#"
							@click.prevent="
								$store.commit('sidebar', 'forgot-password')
							"
							>Glömt lösenordet?</a
						>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Message from "./../partials/Message.vue";
export default {
	name: "SignupBox",
	props: [],
	components: { Message },
	computed: {
		messages() {
			return this.$store.state.messages.sidebar;
		},
		isLoading() {
			return this.$store.state.isLoading;
		}
	},
	data() {
		return {
			email: "",
			password: "",
			user_role: "owner",
			group_name: "",
			company_name: "",
			job_role: "",
			group_key: "",
			invitation_code: "",
			privacy_policy: false
		};
	},
	methods: {
		handleQueryParameters() {
			//http://localhost:4000/malmedvetet-naringsliv/#?show=signup&group_key=5db9539492a6f
			var params = new URLSearchParams(window.location.href);
			var groupKey = params.get("group_key");
			if (groupKey) {
				this.group_key = groupKey;
				this.user_role = "regular";
			}
		},
		doSignup() {
			if (this.isLoading) return;
			this.$store.dispatch("doSignup", {
				email: this.email,
				password: this.password,
				user_role: this.user_role,
				group_name: this.group_name,
				company_name: this.company_name,
				job_role: this.job_role,
				group_key: this.group_key,
				invitation_code: this.invitation_code,
				privacy_policy: this.privacy_policy
			});
		}
	},
	mounted() {
		this.handleQueryParameters();
	}
};
</script>